
import { ArrowRight } from "lucide-react";
import heroBg from "@/assets/orla-maceio.webp";
import heroBgMobile from "@/assets/orla-maceio-mobile.webp";
import { WHATSAPP_URL } from "@/lib/constants";

const HeroSection = () => (
  <section id="inicio" className="relative min-h-[90vh] overflow-hidden pt-16 md:pt-20">
    <div className="absolute inset-0">
      <img
        src={heroBgMobile}
        srcSet={`${heroBgMobile} 800w, ${heroBg} 1280w`}
        sizes="100vw"
        alt=""
        width={1600}
        height={900}
        fetchPriority="high"
        decoding="async"
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/90 via-brand-dark/80 to-brand-dark/50" />
    </div>

    <div className="container relative z-10 flex min-h-[80vh] flex-col justify-center py-16 md:py-24">
      <div className="max-w-2xl">
        <span className="mb-4 inline-block rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary-foreground">
          Especialistas em Crescimento Empresarial
        </span>
        <h1 className="mb-6 text-3xl font-extrabold leading-tight tracking-tight text-primary-foreground sm:text-4xl md:text-5xl lg:text-6xl">
          Sua empresa pode{" "}
          <span className="text-gradient-orange">crescer mais</span> do que você imagina
        </h1>
        <p className="mb-8 max-w-lg text-base leading-relaxed text-primary-foreground/80 sm:text-lg">
          Metodologia própria, validada na prática, para pequenas e médias empresas
          de serviços, varejo e atacado em todo o Brasil.
        </p>
        <div className="flex flex-col gap-4 sm:flex-row">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-orange px-7 py-4 text-base font-bold text-primary-foreground shadow-button transition-transform hover:scale-105"
          >
            Quero Crescer Agora
            <ArrowRight className="h-5 w-5" />
          </a>
          <a
            href="#servicos"
            className="inline-flex items-center justify-center gap-2 rounded-lg border border-primary-foreground/20 px-7 py-4 text-base font-semibold text-primary-foreground transition-colors hover:bg-primary-foreground/10"
          >
            Conheça Nossos Serviços
          </a>
        </div>

        <div className="mt-12 flex flex-wrap gap-8 border-t border-primary-foreground/10 pt-8">
          {[
            { value: "22+", label: "Anos de Experiência" },
            { value: "20", label: "Estados Atendidos" },
            { value: "11", label: "Países" },
          ].map((stat) => (
            <div key={stat.label}>
              <p className="text-2xl font-extrabold text-primary sm:text-3xl">{stat.value}</p>
              <p className="text-sm text-primary-foreground/60">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
